import React from 'react';

import { gql } from '@reverbdotcom/commons/src/gql';
import { useQuery } from '@reverbdotcom/commons/src/useQuery';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { parseAmount } from '@reverbdotcom/commons/src/money';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { RCIcon } from '@reverbdotcom/cadence/components';
import { NudgeTrustBadgeIcon } from '@reverbdotcom/cadence/icons/react';
import { SellerHub_EarningsQuery, SellerHub_EarningsQueryVariables } from '@reverbdotcom/commons/src/gql/graphql';

interface IProps {
  timePeriod?: string;
}

export default function Earnings({ timePeriod = null }: IProps) {
  const user = useUser();
  const { data, loading } = useQuery<SellerHub_EarningsQuery, SellerHub_EarningsQueryVariables>(SELLER_HUB_EARNINGS_QUERY, {
    variables: { timePeriod },
  });

  if (loading) {
    return null;
  }

  const { earnings } = data?.me?.shop || {};
  const defaultAmount = parseAmount('0', user.currency);
  const earningsDefault = { ordersTotal: defaultAmount, accommodationsTotal: defaultAmount };
  const { ordersTotal, accommodationsTotal } = earnings || earningsDefault;

  return (
    <div className="d-flex fx-dir-col">
      <Translate
        tag="div"
        className="seller-hub__earnings"
        text="sellerHub.earnings.youveEarnedHtml"
        args={{
          tagOpen: '<span class="weight-bold">',
          tagClose: '</span>',
          totalEarnings: ordersTotal.display,
        }}
        html
      />
      {!!accommodationsTotal.amountCents &&
        <div className="d-flex fx-align-center mb-5">
          <Translate
            tag="div"
            className="seller-hub__earnings--accommodations"
            text="sellerHub.earnings.fromReverbProtections"
            args={{
              tagOpen: '<span class="weight-bold">',
              tagClose: '</span>',
              accommodationsTotal: accommodationsTotal.display,
            }}
            html
          />
          <RCIcon svgComponent={NudgeTrustBadgeIcon} inline />
        </div>
      }
    </div>
  );
}

export const SELLER_HUB_EARNINGS_QUERY = gql(`
  query SellerHub_Earnings(
    $timePeriod: String
  ) {
    me {
      shop {
        earnings(input: {
          timePeriod: $timePeriod
        }) {
          ordersTotal {
            display
          }
          accommodationsTotal {
            amountCents
            display
          }
        }
      }
    }
  }
`);
